// src/store/modules/auth.js
import AccountService from '@/services/AccountService'

export default {
  namespaced: true,

  state: () => ({
    account: {
      fullName: '',
      email: '',
      password: ''
    },
    token: localStorage.getItem('token') || '',
    timezone: localStorage.getItem('timezone') || 'America/Phoenix'
  }),

  getters: {
    isAuthenticated: state => !!state.token
  },

  mutations: {
    SET_ACCOUNT(state, account) {
      state.account = account
    },
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
      AccountService.setUserToken(token)
    },
    CLEAR_TOKEN(state) {
      state.token = ''
      localStorage.removeItem('token')
      localStorage.removeItem('timezone')
      AccountService.setUserToken(null)
    },
    SET_TIMEZONE(state, tz) {
      state.timezone = tz || 'America/Phoenix'
      localStorage.setItem('timezone', state.timezone)
    }
  },

  actions: {
    async login({ commit, dispatch }, credentials) {
      const response = await AccountService.login(credentials)
      const result = response?.data?.success
      if (!result?.token) throw new Error('Token not received')

      const { token, name, CustomerID, roles = [], asterisk = null, timezone = 'America/Phoenix' } = result

      // persist token + timezone
      commit('SET_TOKEN', token)
      commit('SET_TIMEZONE', timezone)

      // persist account basics
      const nameParts = (name || '').trim().split(' ')
      commit('SET_ACCOUNT', {
        fullName: name || '',
        email: credentials.email,
        password: credentials.password,
        firstName: nameParts[0] || '',
        lastName: nameParts.slice(1).join(' ')
      })

      // store roles & asterisk scope in their modules
      // customerRoles module (you already have)
      commit('customerRoles/setCustomerRoles', roles, { root: true })
      // new asterisk module
      await dispatch('asterisk/setAsterisk', asterisk, { root: true })

      return { roles, asterisk, CustomerID } // <- return clean payload for components
    },

    async register({ commit }, account) {
      const names = account.fullName.trim().split(' ')
      const apiAccount = {
        first_name: names[0],
        last_name: names.slice(1).join(' ') || '',
        email: account.email,
        phone_number: account.phone,
        address: account.address
      }

      const response = await AccountService.register(apiAccount)
      if (!response?.data?.success) throw new Error('Registration failed')

      commit('SET_ACCOUNT', account)
      return true
    },

    async contactUs(_, account) {
      const names = account.fullName.trim().split(' ')
      const payload = {
        first_name: names[0],
        last_name: names.slice(1).join(' ') || '',
        email: account.email,
        phone_number: account.phone,
        message: account.message
      }
      const response = await AccountService.contactUs(payload)
      return !!response?.data?.success
    },

    async forgotPassword(_, email) {
      await AccountService.forgotPassword(email)
    },

    async resetPassword(_, payload) {
      await AccountService.resetPassword(payload)
    },

    logout({ commit, dispatch }) {
      commit('CLEAR_TOKEN')
      commit('SET_ACCOUNT', { fullName: '', email: '', password: '' })
      commit('customerRoles/clearRoles', null, { root: true })
      dispatch('asterisk/clearAsterisk', null, { root: true })
    }
  }
}
